<template>
  <div class="user-list-div"
       style="height:100%">
    <Card style="min-height:100%">
      <Row>
        <Col :span="8">
        <Input search
               enter-button="搜索"
               size="large"
               @on-search="research"
               v-model="requestVO.userName"></Input>
        </Col>
      </Row>
      <br />
      <Row>
        <Table border
               ref="tablesMain"
               :data="tableData"
               :columns="columns">
          <template slot-scope="{ row, index }"
                    slot="handle">
            <Button type="primary"
                    size="small"
                    v-show="!isAuth"
                    style="margin-left:5px;"
                    @click="goResetPwd(row.userID)">初始化密码</Button>
            <Button type="primary"
                    size="small"
                    v-show="row.userUsesMark==0"
                    @click="renderUsesMark(row.userID,1)"
                    style="margin-left:5px;">启用</Button>
            <Button type="primary"
                    size="small"
                    v-show="row.userUsesMark==1"
                    @click="renderUsesMark(row.userID,0)"
                    style="margin-left:5px;">禁用</Button>
            <Button type="primary"
                    size="small"
                    v-show="!isAuth"
                    style="margin-left:5px;"
                    @click="goEditUser(row)">编辑</Button>
            <Button type="error"
                    size="small"
                    v-show="!isAuth&&row.userIsSuperAdmin==0"
                    style="margin-left:5px;"
                    @click="goDeleteUser(row)">删除</Button>
          </template>
        </Table>
        <br />
        <Page :total="total"
              show-total
              v-if="total!=0"
              :page-size="requestVO.pageSize"
              :current="requestVO.pageIndex+1"
              @on-change="changePageIndex" />
      </Row>
    </Card>
  </div>
</template>
<script>

import {
  queryUserPageList,
  editUsesMark,
  deleteUser,
  resetUserPassword
} from "@/api/user/user.js";
import { mapMutations, mapActions, mapGetters } from "vuex";
export default {
  name: "UserList",

  data () {
    return {
      requestVO: {
        userName: "",
        pageIndex: 0,
        pageSize: 10
      },
      total: 0,
      userTypeMap: new Map([[0, "普通用户"], [1, "超级管理员"]]),
      userStatusMap: new Map([[0, "禁用"], [1, "启用"]]),
      tableData: [],
      columns: [
        {
          title: "用户名",
          key: "userLoginName",
          tooltip: true,
          align: "center"
        },
        {
          title: "用户类型",
          key: "userTypeName",
          tooltip: true,
          width: "110px",
          align: "center"
        },
        {
          title: "状态",
          key: "userStatusName",
          tooltip: true,
          width: "70px",
          align: "center"
        },
        {
          title: "用户创建时间",
          key: "userCreateTime",
          tooltip: true,
          width: "180px",
          align: "center"
        },
        {
          title: "用户激活时间",
          key: "userEnabledTime",
          tooltip: true,
          width: "180px",
          align: "center"
        },
        {
          title: "用户失效时间",
          key: "userInvalidTime",
          tooltip: true,
          width: "180px",
          align: "center"
        },
        {
          title: "操作",
          slot: "handle",
          tooltip: true,
          width: "300px"
        }
      ]
    };
  },
  computed: {
    isAuth () {
      return this.$route.meta.isAuth;
    }
  },
  created () {
    this.renderUserPageList();
  },
  methods: {
    //...mapMutations(["setUser"]),
      ...mapMutations('user', {
      $_setUser: 'setUser',
   }),
    changePageIndex (current) {
      this.requestVO.pageIndex = current - 1;
      this.renderUserPageList();
    },
    renderUsesMark (userID, userUsesMark) {
      editUsesMark(userID, userUsesMark).then(res => {
        if (res.data.result) {
          this.research();
        }
      });
    },
    goEditUser (user) {
      debugger
       this.$_setUser(user);
      //this.setUser(user);
      this.$router.push("userDetail");
    },
    goResetPwd (userID) {
      resetUserPassword(userID).then(res => {
        this.$Message.info("密码初始化为123456");
      });
    },
    research () {
      this.requestVO.pageIndex = 0
      this.renderUserPageList()
    },
    goDeleteUser (user) {
      this.$Modal.confirm({
        title: "确认框",
        content: "确认删除" + user.userLoginName + "?",
        onOk: () => {
          deleteUser(user.userID).then(res => {
            this.research();
          });
        }
      });
    },
    renderUserPageList () {
      queryUserPageList(this.requestVO).then(res => {
        this.total = res.data.total;
        let resultData = res.data.data;
        this.tableData = resultData.map(element => {
          let resultObj = { ...element };
          resultObj.userTypeName = this.userTypeMap.get(
            element.userIsSuperAdmin
          );
          resultObj.userStatusName = this.userStatusMap.get(
            element.userUsesMark
          );
          return resultObj;
        });
      });
    }
  }
};
</script>
